import { Field } from "formik";
import { FieldShell, fieldInputClassName } from "./FieldShell";
import type { Keys } from "./formik";

type FormFieldProps = {
  name: Keys;
  label: string;
  required?: boolean;
  multiline?: boolean;
  type?: "text" | "email" | "tel";
  autoComplete?: string;
};

export const FormField = ({
  name,
  label,
  required = false,
  multiline = false,
  type = "text",
  autoComplete,
}: FormFieldProps) => {
  // Emails and phone numbers read left-to-right even on the Arabic page.
  const isLatinOnly = type === "email" || type === "tel";

  return (
    <FieldShell name={name} label={label} required={required}>
      {multiline ? (
        <Field
          as="textarea"
          id={name}
          name={name}
          className={`${fieldInputClassName} min-h-[100px] resize-y`}
        />
      ) : (
        <Field
          id={name}
          name={name}
          type={type}
          autoComplete={autoComplete}
          dir={isLatinOnly ? "ltr" : undefined}
          className={fieldInputClassName}
        />
      )}
    </FieldShell>
  );
};
